import { memo } from 'react';
import { Box, Button, FelaCSS } from '@bridebook/ui';
import mergeStyles from '@bridebook/ui/src/fela-utils/merge-styles';
import { IModalProps } from '@bridebook/web/app-shared/components/modal';
import Modal from '@bridebook/web/components/bbcommon/modal';
import componentStyles from './popup-rounded.style';
import { Icon } from '@bridebook/aura';
import { Close } from '@bridebook/aura/src/icons';

interface IProps
  extends Pick<
    IModalProps,
    'show' | 'id' | 'onClose' | 'maxWidth' | 'fullScreenModal' | 'instant'
  > {
  children: React.ReactNode;
  modalStyle?: FelaCSS;
  buttonStyle?: FelaCSS;
}

const PopupRounded = ({
  show,
  onClose,
  id,
  children,
  modalStyle,
  maxWidth,
  buttonStyle = {},
  fullScreenModal,
  instant,
}: IProps) => {
  const styles = componentStyles();

  return (
    <Modal {...{ show, onClose, id, maxWidth, fullScreenModal, instant }}>
      <Box style={mergeStyles([styles.contentWrap, modalStyle || {}])}>
        {onClose && (
          <Box style={mergeStyles([styles.buttonWrap, buttonStyle])}>
            <Button
              theme="ghost"
              color="space"
              icon={<Icon icon={Close} size={24} className="stroke-2" />}
              onClick={onClose}
            />
          </Box>
        )}
        {children}
      </Box>
    </Modal>
  );
};

export default memo(PopupRounded);
